module.exports = __webpack_public_path__ + "img/2.66d2ba93.jpg";